import BreadCrumbs from 'components/breadcrumbs'
import CustomButton from 'components/Buttons/CustomButton'
import { useSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  Card,
  CardBody,
  CardText,
  Container,
  FormGroup,
  Input,
  Label,
} from 'reactstrap'
import {
  URL_EVENT,
  URL_EVENT_PARTICIPANT,
  URL_EVENT_TIMELINE,
} from 'utils/pathUrl'
import {
  useAddEventParticipantMutation,
  useEditEventParticipantMutation,
  useFetchUsersListEventQuery,
  useLazyFetchUsersListEventQuery,
} from './eventParticipantApiSlice'
import PMBSelect from 'components/PMBSelect'
import {
  useFetchEventForFormQuery,
  useFetchUtilsEventQuery,
} from '../event/eventApiSlice'

const FormEventParticipant = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const { enqueueSnackbar } = useSnackbar()
  const dataState = location.state

  const [payload, setPayload] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [usersData, setUsersData] = useState([])

  const [addEventParticipant, resAddEventParticipant] =
    useAddEventParticipantMutation()
  const [updateEventParticipant, resUpdateEventParticipant] =
    useEditEventParticipantMutation()

  const [getUsers] = useLazyFetchUsersListEventQuery()

  // const resUtils = useFetchUtilsEventQuery()
  const resUsers = useFetchUsersListEventQuery()

  const handleSubmit = async () => {
    try {
      const body = {
        eventId: payload?.eventId,
        objectId: payload?.objectId,
        // status: payload?.status,
        // certificateNumber: payload?.certificateNumber,
        // certificateUrl: payload?.certificateUrl,
        ...(dataState?.typeAction === 'edit' && {
          id: payload?.id || dataState?.id,
        }),
        note: payload?.note,
        objectType: dataState?.objectType,
      }
      const result =
        dataState?.typeAction === 'edit'
          ? await updateEventParticipant(body)
          : await addEventParticipant(body)

      if (result?.error) {
        throw result
      } else {
        navigate(-1)
        enqueueSnackbar(
          `Peserta Event berhasil ${dataState?.typeAction === 'edit' ? 'diubah' : 'ditambah'}`,
          {
            variant: 'success',
          },
        )
      }
    } catch (error) {
      enqueueSnackbar(
        error?.error?.data?.message ||
          error?.error?.message ||
          error?.error?.originalStatus ||
          error,
        {
          variant: 'error',
        },
      )
    }
  }

  useEffect(() => {
    if (dataState) {
      setPayload(dataState)
    }
  }, [dataState])

  useEffect(() => {
    const fetchAllUsers = async () => {
      if (resUsers?.data?.items?.length < resUsers?.data?.totalItems) {
        const { data } = await getUsers({ size: resUsers?.data?.totalItems })
        setUsersData(data)
      } else {
        setUsersData(resUsers?.data)
      }
    }

    fetchAllUsers()
  }, [resUsers])

  return (
    <>
      <Container className="custom-container d-flex flex-column gap-1 py-2">
        <div className="pt-3">
          <BreadCrumbs
            breadCrumbActive={`${dataState ? 'Edit' : 'Tambah'} Peserta Event`}
            breadCrumbParent={'Event'}
            breadCrumbParentOnClick={() => navigate(URL_EVENT)}
            breadCrumbParent3={'Peserta Event'}
            breadCrumbParent3OnClick={() => navigate(-1)}
          />
        </div>
        <Card className="border-0 shadow-sm">
          <CardBody>
            <CardText tag="h5" className="pb-4">
              {dataState ? 'Edit' : 'Tambah'} Peserta Event
            </CardText>
            <FormGroup>
              <Label>Event Terkait</Label>
              <Input
                disabled
                value={dataState?.title}
                id="title"
                name="title"
                data-testid="event-participant-form-event"
              />
            </FormGroup>
            <FormGroup>
              <Label>Peserta</Label>
              <PMBSelect
                style={{ width: '100%' }}
                options={usersData?.newData}
                value={
                  usersData?.newData?.find(
                    (option) =>
                      String(option.value) === String(payload?.objectId),
                  ) ?? null
                }
                onChange={(e) => {
                  setPayload((prev) => ({
                    ...prev,
                    objectId: e?.value,
                  }))
                }}
                isClearable
                testId="event-participant-form-participant"
              />
            </FormGroup>

            {/* <FormGroup>
              <Label>Status</Label>
              <PMBSelect
                style={{ width: '100%' }}
                options={resUtils?.data?.eventParticipantStatus}
                value={
                  resUtils?.data?.eventParticipantStatus?.find(
                    (option) =>
                      String(option.value) === String(payload?.status),
                  ) ?? null
                }
                onChange={(e) => {
                  setPayload((prev) => ({
                    ...prev,
                    status: e?.value,
                  }))
                }}
                isClearable
              />
            </FormGroup> */}

            {/* <FormGroup>
              <Label>Nomor Sertifikat (opsional)</Label>
              <Input
                onChange={(e) => {
                  setPayload((prev) => ({
                    ...prev,
                    certificateNumber: e.target?.value,
                  }))
                }}
                value={payload?.certificateNumber}
                id="certificateNumber"
                name="certificateNumber"
                placeholder="Masukkan Nomor Sertifikat"
              />
            </FormGroup>

            <FormGroup>
              <Label>Link Sertifikat (opsional)</Label>
              <Input
                onChange={(e) => {
                  setPayload((prev) => ({
                    ...prev,
                    certificateUrl: e.target?.value,
                  }))
                }}
                value={payload?.certificateUrl}
                id="certificateUrl"
                name="certificateUrl"
                placeholder="Masukkan Link Sertifikat"
              />
            </FormGroup> */}

            <FormGroup>
              <Label>Catatan (opsional)</Label>
              <Input
                onChange={(e) => {
                  setPayload((prev) => ({
                    ...prev,
                    note: e.target?.value,
                  }))
                }}
                value={payload?.note}
                id="note"
                name="note"
                type="textarea"
                placeholder="Masukkan Catatan"
                data-testid="event-participant-form-note"
              />
            </FormGroup>

            <div className="d-flex gap-3">
              <CustomButton
                onClick={() => navigate(-1)}
                outline
                className="btn-cancel"
                block
                testId="event-participant-form-cancel-button"
              >
                Batal
              </CustomButton>
              <CustomButton
                onClick={() => handleSubmit()}
                disabled={isLoading || !payload?.objectId || !payload?.eventId}
                block
                color="primary"
                testId="event-participant-form-submit-button"
              >
                Simpan
              </CustomButton>
            </div>
          </CardBody>
        </Card>
      </Container>
    </>
  )
}

export default FormEventParticipant
